
import { Link } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PricingHeader from "./components/pricing/PricingHeader";
import PricingHero from "./components/pricing/PricingHero";
import PricingPlans from "./components/pricing/PricingPlans";
import PricingFAQ from "./components/pricing/PricingFAQ";
import PricingFooter from "./components/pricing/PricingFooter";
import PageSEO from "@/components/seo/PageSEO";
import StructuredData from "@/components/seo/StructuredData";

const PricingPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-godyspo-background text-white">
      <PageSEO
        title="Wholesale Real Estate Software Pricing | Dispo Platform | GoDyspo"
        description="Affordable disposition software for wholesalers. List unlimited properties, manage unlimited buyers, close more deals. Start your 30-day free trial. No hidden fees."
        canonical="/pricing"
        keywords="wholesale real estate software pricing, dispo software pricing, disposition platform cost, real estate wholesaler software, InvestorLift pricing alternative"
      />
      <StructuredData 
        type="BreadcrumbList" 
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Pricing", url: "/pricing" }
        ]} 
      />
      <PricingHeader />

      <section className="py-16 flex-1">
        <div className="container mx-auto px-4">
          <PricingHero />

          <div className="max-w-5xl mx-auto">
            <Tabs defaultValue="monthly" className="flex flex-col items-center mb-12">
              <TabsList>
                <TabsTrigger value="monthly">Monthly</TabsTrigger>
                <TabsTrigger value="annually">Annually</TabsTrigger>
              </TabsList>
              
              <TabsContent value="monthly" className="w-full mt-8">
                <PricingPlans billingPeriod="monthly" />
              </TabsContent>
              
              <TabsContent value="annually" className="w-full mt-8">
                <PricingPlans billingPeriod="annually" />
              </TabsContent>
            </Tabs>

            <div className="text-center mt-8 text-muted-foreground">
              All plans include access to our easy-to-use platform with no hidden fees.
              <br />
              Need a custom solution? <Link to="/contact" className="text-godyspo-gold hover:underline">Contact us</Link>
            </div>
          </div>
        </div>
      </section>

      <PricingFAQ />
      <PricingFooter />
    </div>
  );
};

export default PricingPage;
